import { createFileRoute } from "@tanstack/react-router";
import { Escalations } from "@/components/Escalations";

function RouteComponent() {
  return <Escalations />;
}

export const Route = createFileRoute("/_authenticated/escalations/")({
  component: RouteComponent,
  staticData: { page: "operations" },
});
